module.exports = __webpack_public_path__ + "img/polarR.ffacf2b3.svg";